import React from "react";
import { pdf, DocumentProps } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

type PdfDocumentElement = React.ReactElement<DocumentProps>;

/**
 * Generate and download a PDF document
 * @param document - React component that returns a PDF Document
 * @param fileName - Name of the file to download
 */
export const downloadPDF = async (
  document: React.ReactElement,
  fileName: string
) => {
  try {
    const blob = await pdf(document as PdfDocumentElement).toBlob();
    saveAs(blob, fileName);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};

/**
 * Generate PDF as blob
 * @param document - React component that returns a PDF Document
 * @returns Promise<Blob> PDF blob
 */
export const generatePDFBlob = async (
  document: React.ReactElement
): Promise<Blob> => {
  try {
    const blob = await pdf(document as PdfDocumentElement).toBlob();
    return blob;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};

/**
 * Generate PDF as URL
 * @param document - React component that returns a PDF Document
 * @returns Promise<string> URL to the PDF blob
 */
export const generatePDFUrl = async (
  document: React.ReactElement
): Promise<string> => {
  try {
    const blob = await pdf(document as PdfDocumentElement).toBlob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
